export default "__VITE_ASSET__DQTU392u__"